import { render, staticRenderFns } from "./singleComment.vue?vue&type=template&id=52c4de70&scoped=true&"
import script from "./singleComment.vue?vue&type=script&lang=js&"
export * from "./singleComment.vue?vue&type=script&lang=js&"
import style0 from "./singleComment.vue?vue&type=style&index=0&id=52c4de70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4de70",
  null
  
)

export default component.exports